export default function assignedcalleds(state = [], action) {
    switch (action.type) {
        case 'ADD_CURRENT':
            return {
                ...state,
                assignedcalled: action.assignedcalled,
            }
        default:
            return state;
    }
}
